<template>
    <div class="form-page">
        <my-form v-model="form" @submit="submitHandler" table>
            <my-form-item-group title="招标异常终止信息">
                <el-form-item label="标段名称" prop="bdname" class="table-full-row" :rules="newRule('标段名称', 'required')">
                    <el-radio-group :disabled="disabledBlur" v-model="form.bdname" @change="setbdtype">
                        <el-radio v-for="(v,i) in bdlist" :key="i" :label="v.bdname" :value="v.name"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="招标异常类型" prop="extyctype" class="table-full-row" :rules="newRule('招标类型', 'required','string')">
                      <el-select v-model="form.extyctype" placeholder="请选择">
                            <el-option
                            v-for="item in ycoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                </el-form-item>
                <el-form-item label="内容" v-if="form.extyctype!=='废标公告'"  prop="yccontent" class="table-full-row" :rules="newRule('内容', 'required')">
                    <el-input v-model="form.yccontent" type="textarea" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="异常情况描述" v-if="form.extyctype==='废标公告'" prop="yccontent" class="table-full-row" :rules="newRule('异常情况描述', 'required')">
                    <el-input v-model="form.yccontent"  type="textarea" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="交易方式" v-if="form.extyctype!=='废标公告'" prop="by3" class="table-full-row" :rules="newRule('交易方式', 'required')">
                    <el-input v-model="form.by3"  type="textarea" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="成交结果" v-if="form.extyctype!=='废标公告'" prop="by4" class="table-full-row" :rules="newRule('成交结果', 'required')">
                    <el-input v-model="form.by4"  type="textarea" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload   :file-guid="form.fileguid|| ''"></my-upload>
                </el-form-item>
            </my-form-item-group>
            <template slot="btn" class="btn" slot-scope="scope">
                <el-button icon="el-icon-circle-check" type="primary" :disabled="disabled" @click="fSave('1',scope.submitHandler)">
                    提交
                </el-button>
                <el-button  icon="el-icon-remove-outline" type="warning" :disabled="disabled" @click="fSave('0',scope.submitHandler)">
                    暂存
                </el-button>    
            </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
export default {
    mixins: [FORM_PAGE_MIXIN],
    data() {
        return{
            tableData:[],
            dialogVisible:false,
            form:{
                shbj:'',
                yccode:'',
                bdcode:'',
                bdname:'',
                fileguid:''
            },
            disabled:false,
            pgData:{
                procode:'',
                sortname:'yccode',
                pageindex:'1',
                sortorder:'desc',
                pagesize:'20'
            },
            xxbdlist:[],
            bdlist:[],
            ycoptions:[
                {value:'废标公告',lable:'1'},
                {value:'撤项',lable:'2'},
                {value:'报名家数不足',lable:'3'},
                {value:'重新招标',lable:'4'},
                {value:'重新评标',lable:'5'},
                {value:'变更招标方式',lable:'6'},
                {value:'其他',lable:'7'},
            ],
            disabledBlur:false,
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        // 提交
        fSave:function(id,cb){          
            this.form.shbj=id;
            cb()
        },
        submitHandler:function(){
            var that=this
            this.disabled=true;
            that.$post(`${this.getGetters('bidUrl')}/Zbzz/ZbYcZz/add.json`,$.param(this.form), (data, res) => {
                that.disabled=false;
                if (res.result) {
                    ShowMsg(res.msg,'success')                    
                    that.cancleHandler();
                } else {
                    ShowMsg(res.msg)
                }
            });
        },
        setbdtype:function(data){
            this.form.bdname=data;
            
            for(var i=0;i<this.bdlist.length;i++){
                if(this.bdlist[i].bdname==data){
                    this.form.bdcode=this.bdlist[i].bdcode
                    this.form.by1=this.bdlist[i].bdcode
                }
            }         
        },
        closedialog:function(type){
            this.dialogVisible=type;
        }
    },
    created() {

    },
    mounted() {
        var that=this
   
        if(this.$route.query.yccode!==undefined){
            this.disabledBlur = true;
            this.pgData.procode=this.$route.query.procode
            that.$get(`${this.getGetters('bidUrl')}/Zbzz/ZbYcZz/ycedit.json`,{procode:this.$route.query.procode}, (data, res) => {
                that.bdlist=data.bdlist;
            });
            that.$get(`${this.getGetters('bidUrl')}/Zbzz/ZbYcZz/ycdetail.json`,{id:this.$route.query.yccode}, (data, res) => {
                that.form=data.model;
            });
        }else{
            that.$get(`${this.getGetters('bidUrl')}/Zbzz/ZbYcZz/ycedit.json`,{procode:this.$route.query.procode}, (data, res) => {
                that.bdlist=data.bdlist
                that.form=JSON.parse(data.model) 
                this.form.procode=this.$route.query.procode
            });
        }

    }
}
</script>

<style scoped lang="scss">

</style>
